var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('router-view'),_vm._v(" "),_c('v-snackbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNewUpdateMessage),expression:"showNewUpdateMessage"}],attrs:{"top":true,"timeout":10000},model:{value:(_vm.showNewUpdateMessage),callback:function ($$v) {_vm.showNewUpdateMessage=$$v},expression:"showNewUpdateMessage"}},[_vm._v("\n        "+_vm._s(_vm.newUpdate.text)+"\n        "),_c('v-btn',{attrs:{"color":"pink","flat":""},on:{"click":_vm.reloadPage}},[_vm._v("\n            Recargar\n        ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/AppView.vue?vue&type=template&id=43d958a7&
// module id = 173
// module chunks = 32